export enum AccountsColumns {
	id = "Id",
	org = "Org",
	bank = "Bank",
	name = "Name",
	type = "Type",
	createdAt = "Created At",
	updatedAt = "Updated At",
	balance = "Balance",
	product = "Product",
	status = "Status",
	routingNumber = "Routing Number",
	accountNumber = "Account Number",
	purpose = "Purpose",
}

export type AllowedAccountsColumns =
	| AccountsColumns.id
	| AccountsColumns.org
	| AccountsColumns.bank
	| AccountsColumns.name
	| AccountsColumns.type
	| AccountsColumns.createdAt
	| AccountsColumns.updatedAt
	| AccountsColumns.balance
	| AccountsColumns.product
	| AccountsColumns.status
	| AccountsColumns.routingNumber
	| AccountsColumns.accountNumber
	| AccountsColumns.purpose

export enum AccountCustomerType {
	individual = "individual",
	business = "business",
	businessFBO = "businessFBO",
	individualWallet = "individualWallet",
}
